import { render, staticRenderFns } from "./mark-detail.vue?vue&type=template&id=30d06c7d&scoped=true&"
import script from "./mark-detail.vue?vue&type=script&lang=js&"
export * from "./mark-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d06c7d",
  null
  
)

export default component.exports